<template>
  <li
    @touchstart="onTouchStart"
    class="group/menu-section inline-block relative"
  >
    <router-link
      v-if="to"
      :to="to"
      custom
      v-slot="{ href, route, navigate, isActive, isExactActive }"
    >
      <a
        :href="href"
        :class="[
          { 'has-nested-list': items?.length },
          isActive
            ? 'bg-blush-500 hover:bg-blush-600 text-orange-500'
            : 'bg-orange-500 hover:bg-orange-600 text-white',
          'px-[16px]',
          'group-[&:nth-child(2)]/menu-section:rounded-l-full',
          'group-last/menu-section:rounded-r-full',
          'transition-none',
          'transform-none',
        ]"
        class="button block py-[12px] z-10"
        @click="navigate"
      >
        {{ title }}
      </a>
    </router-link>
    <template v-else>{{ title }}</template>

    <ul
      :class="[
        'seasons-list absolute top-[40px] hidden group-hover/menu-section:block z-11 translate-x-0',
        'group-[&:nth-child(2)]/menu-section:right-[-1px] left-auto',
      ]"
    >
      <!-- `translate-x-0`: Hoisting the stacking context + z-index above
      e.g. video previews and other transformed elements -->
      <li v-for="(item, index) in items" :key="item.key">
        <router-link :to="item.to" custom v-slot="{ href, navigate, isActive }">
          <a
            :href="href"
            @click="navigate"
            class="block py-3 px-4 text-white whitespace-nowrap hover:bg-orange-600 bg-orange-500"
            :class="[
              isActive ? 'bg-blush-500 hover:bg-blush-600' : '',
              index === 0
                ? [
                    'group-[&:nth-child(2)]/menu-section:rounded-tl-[20px]',
                    'group-[&:not(:nth-child(2))]/menu-section:rounded-tr-[20px]',
                  ]
                : '',
              index === items.length - 1
                ? 'rounded-bl-[20px] rounded-br-[20px]'
                : '',
            ]"
          >
            {{ item.title }}
          </a>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "MenuSection",
  components: {
    RouterLink,
  },
  props: {
    to: {
      type: Object,
    },
    title: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
    },
  },
  methods: {
    onTouchStart(e) {
      if (e.target.classList.contains("has-nested-list")) {
        e.preventDefault();

        const nestedList = e.currentTarget.querySelector("ul");
        nestedList.classList.remove("hidden");

        document.addEventListener(
          "click",
          () => {
            nestedList.classList.add("hidden");
          },
          { once: true, passive: true },
        );
      }
    },
  },
};
</script>
